import { useEffect } from 'react';

type ExternalRedirectProps = {
  to: string;
};

/**
 * Redirects to the given path, replacing the current
 * window location.
 */
export const ExternalRedirect = ({ to }: ExternalRedirectProps) => {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return null;
};
